import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2834d45f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fd-invest-list" }
const _hoisted_2 = { class: "fd-invest-list-content" }
const _hoisted_3 = { class: "fd-invest-list-search" }
const _hoisted_4 = {
  key: 0,
  class: "fd-invest-list-search-hd-check"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 已选择： ")
const _hoisted_6 = { class: "fd-invest-list-search-box" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 发布时间")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("仅显示进行中的")
const _hoisted_12 = { class: "fd-invest-list-ct" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "fd-invest-box-item-img" }
const _hoisted_15 = { class: "fd-invest-box-item-img-label" }
const _hoisted_16 = { class: "fd-invest-box-item-info" }
const _hoisted_17 = { class: "fd-invest-box-item-info-tp-lt" }
const _hoisted_18 = { class: "fd-invest-box-item-info-tp-lt-name" }
const _hoisted_19 = { class: "fd-invest-box-item-info-tp-label" }
const _hoisted_20 = { class: "fd-invest-box-item-info-bt-name" }
const _hoisted_21 = { style: {"position":"relative","top":"-8px"} }
const _hoisted_22 = { class: "load-more" }

import { ref, reactive } from "vue";
import store from "@/store/index";
import router from "@/router/index";
import Bottom from "../components/bottom.vue";

interface ActivityVo {
  id: string;
  name: string;
  roomNumberName: string;
  deliveryDateString: string;
  decorateTypeName: string;
  thumbnailUrl: string;
  projectName: string;
  companyName: string;
  distanceDay: number;
}
interface tabNames {
  name: string;
  count: string;
}
interface tags {
  name: string;
  type: string;
}
interface joinCategorys {
  id: string;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

var timeType = localStorage.getItem('timeTypeSearch');
localStorage.setItem('timeTypeSearch', '');
if (timeType == null || timeType.length <= 0) {
  timeType = "all";
}

const isApply = ref(false);
const isShow = ref(false);
const pushTimeUpSort = ref(true);
const remainCount = ref(0);
const searchItemSize = ref(10);
const selectJoinCategorys = ref(["不限"]);
const selectProvinces = ref(["不限"]);
const selectBrandNames = ref(["不限"]);
const selectQuarters = ref(["不限"]);
const selectTimeType = ref([timeType]);

const activeNames = ref(["1"]);
const handleChange = (val: string[]) => {
  console.log(val);
};

const investActivitys: ActivityVo[] = [];
const tags: tags[] = [];
const joinCategorys: joinCategorys[] = [];
const bindData = reactive({
  brandTotalCount: 0,
  provinceTotalCount: 0,
  joinCategoryTotalCount: 0,
  brandMax: 10,
  provinceMax: 10,
  joinCategoryMax: 10,
  tags: tags,
  joinCategorys: joinCategorys,
  decorateTypes: [],
  houseNatures: [],
  provinces: [],
  quarters: [],
  timeSearchTypes: [],
  brandNames: [],
  calssType: ["", "", "", "status3", "status4", "status5", "status6"],
  type: ["", "", "", "即将开始", "报名中", "进行中", "已结束"],
  images: {},
  sumCounts: {},
  pageParams: {
    curPage: 1,
    pageSize: 9,
    orderField: "push_time",
    orderingRule: "DESC",
    filtrate: {
      status: "",
      keyword: "",
      type: "1",
      paymentWay: "",
      paymentModel: "",
      houseNatureId: "",
      decorateTypeId: "",
      roomNumberCode: "",
      roomNumberStart:"",
      roomNumberEnd:"",
      houseAveragePriceCode: "",
      brandNames: "",
      joinCategoryIdses: "",
      provinces: "",
      joinQuantitys: "",
      quarters: "",
      timeType: timeType
    },
  },
  pageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
});

const activityEvent = (isAppend: boolean) => {
  store
    .dispatch("frontInvestModule/pageActivityList", bindData.pageParams)
    .then(
      (data) => {
        //成功
        if (isAppend) {
          data.result = bindData.pageResult.result.concat(data.result);
        }
        bindData.pageResult = data;
        remainCount.value = data.totalCount - bindData.pageResult.result.length;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const decorateTypeEvent = () => {
  store.dispatch("frontInvestModule/listDecorateType").then(
    (data) => {
      bindData.decorateTypes = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const joinCategoryEvent = () => {
  store.dispatch("frontInvestModule/listJoinCategory", { type: 1 }).then(
    (data) => {
      bindData.joinCategoryMax = data.totalCount < searchItemSize.value ? (data.totalCount + 1) : searchItemSize.value
      bindData.joinCategorys = data.result;
      bindData.joinCategoryTotalCount = data.totalCount;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const houseNatureEvent = () => {
  store.dispatch("frontInvestModule/listHouseNature").then(
    (data) => {
      bindData.houseNatures = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const activityBrandEvent = () => {
  store.dispatch("frontInvestModule/listActivityBrand", { type: 1 }).then(
    (data) => {
      bindData.brandMax = data.totalCount < searchItemSize.value ? (data.totalCount + 1) : searchItemSize.value
      bindData.brandNames = data.result;
      bindData.brandTotalCount = data.totalCount;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const provinceEvent = () => {
  store.dispatch("frontInvestModule/listActivityProvince", { type: 1 }).then(
    (data) => {
      bindData.provinceMax = data.totalCount < searchItemSize.value ? (data.totalCount + 1) : searchItemSize.value
      bindData.provinces = data.result;
      bindData.provinceTotalCount = data.totalCount;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const quarterEvent = () => {
  store.dispatch("frontInvestModule/listLastQuarterBetween").then(
    (data) => {
      bindData.quarters = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const timeTypeEvent = () => {
  store.dispatch("frontInvestModule/listTimeSearchTypes").then(
    (data) => {
      bindData.timeSearchTypes = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const searchEvent = (isAppend: boolean) => {
  const joinCategorys = selectJoinCategorys.value.filter(
    (tag) => tag !== "不限"
  );
  const provinces = selectProvinces.value.filter((tag) => tag !== "不限");
  const brandNames = selectBrandNames.value.filter((tag) => tag !== "不限");
  const quarters = selectQuarters.value.filter((tag) => tag !== "不限");
  const timeType = selectTimeType.value.filter((tag) => tag !== "all");
  bindData.pageParams.filtrate.joinCategoryIdses = joinCategorys.join(",");
  bindData.pageParams.filtrate.brandNames = brandNames.join(",");
  bindData.pageParams.filtrate.provinces = provinces.join(",");
  bindData.pageParams.filtrate.quarters = quarters.join(",");
  bindData.pageParams.filtrate.timeType = timeType.length > 0 ? timeType[0] : "";
  let roomNumberCode = bindData.pageParams.filtrate.roomNumberCode;
  bindData.pageParams.filtrate.roomNumberStart = "";
  bindData.pageParams.filtrate.roomNumberEnd = "";
  if(roomNumberCode){
     bindData.pageParams.filtrate.roomNumberStart = roomNumberCode.split("-")[0];
     bindData.pageParams.filtrate.roomNumberEnd = roomNumberCode.split("-")[1];
  } 
  bindData.tags = [];
  if (provinces) {
    for (var province of provinces) {
      var tag = { name: "", type: "" };
      tag.name = province;
      tag.type = "province_" + province;
      bindData.tags.push(tag);
    }
  }
  if (brandNames) {
    for (var brandName of brandNames) {
      var tag = { name: "", type: "" };
      tag.name = brandName;
      tag.type = "brand_" + brandName;
      bindData.tags.push(tag);
    }
  }
  if (quarters) {
    for (var quarter of quarters) {
      var tag = { name: "", type: "" };
      tag.name = quarter + "季度";
      tag.type = "quarter_" + quarter;
      bindData.tags.push(tag);
    }
  }
  if (joinCategorys) {
    for (var joinCategoryId of joinCategorys) {
      for (var i = 0; i < bindData.joinCategorys.length; i++) {
        var joinCategory = bindData.joinCategorys[i];
        if (joinCategory.id == joinCategoryId) {
          var tag = { name: "", type: "" };
          tag.name = joinCategory.name;
          tag.type = "joinCategory_" + joinCategoryId;
          bindData.tags.push(tag);
        }
      }

    }
  }
  activityEvent(isAppend);
};

const reloadSearchEvent = () => {
  bindData.pageParams.curPage = 1;
  bindData.pageParams.pageSize = 9;
  if (bindData.pageParams.filtrate.provinces.length == 0) {
    if (selectProvinces.value.length > 1) {
      selectProvinces.value = selectProvinces.value.filter(
        (tag) => tag !== "不限"
      );
    }
  } else if (selectProvinces.value.includes("不限")) {
    selectProvinces.value = ["不限"];
  }
  if (bindData.pageParams.filtrate.joinCategoryIdses.length == 0) {
    if (selectJoinCategorys.value.length > 1) {
      selectJoinCategorys.value = selectJoinCategorys.value.filter(
        (tag) => tag !== "不限"
      );
    }
  } else if (selectJoinCategorys.value.includes("不限")) {
    selectJoinCategorys.value = ["不限"];
  }
  if (bindData.pageParams.filtrate.brandNames.length == 0) {
    if (selectBrandNames.value.length > 1) {
      selectBrandNames.value = selectBrandNames.value.filter(
        (tag) => tag !== "不限"
      );
    }
  } else if (selectBrandNames.value.includes("不限")) {
    selectBrandNames.value = ["不限"];
  }
  if (bindData.pageParams.filtrate.quarters.length == 0) {
    if (selectQuarters.value.length > 1) {
      selectQuarters.value = selectQuarters.value.filter(
        (tag) => tag !== "不限"
      );
    }
  } else if (selectQuarters.value.includes("不限")) {
    selectQuarters.value = ["不限"];
  }
  if (isApply.value) {
    bindData.pageParams.filtrate.status = "4";
  } else {
    bindData.pageParams.filtrate.status = "";
  }
  //因为是单选，所以取最后一个值
  selectTimeType.value = [selectTimeType.value[selectTimeType.value.length - 1]];
  searchEvent(false);
};

const loadPageDataEvent = () => {
  if (
    bindData.pageParams.curPage * bindData.pageParams.pageSize <
    bindData.pageResult.totalCount
  ) {
    bindData.pageParams.curPage = bindData.pageParams.curPage + 1;
    searchEvent(true);
  }
};

const removeSearchTagEvent = (type: string) => {
  if (type) {
    var t = type.split("_")[0];
    var name = type.split("_")[1];
    if (t == "province") {
      selectProvinces.value = selectProvinces.value.filter(
        (tag) => tag !== name
      );
      if (selectProvinces.value.length <= 0) {
        selectProvinces.value = ["不限"];
      }
    }
    if (t == "joinCategory") {
      selectJoinCategorys.value = selectJoinCategorys.value.filter(
        (tag) => tag !== name
      );
      if (selectJoinCategorys.value.length <= 0) {
        selectJoinCategorys.value = ["不限"];
      }
    }
    if (t == "brand") {
      selectBrandNames.value = selectBrandNames.value.filter(
        (tag) => tag !== name
      );
      if (selectBrandNames.value.length <= 0) {
        selectBrandNames.value = ["不限"];
      }
    }
    if (t == "quarter") {
      selectQuarters.value = selectQuarters.value.filter(
        (tag) => tag !== name
      );
      if (selectQuarters.value.length <= 0) {
        selectQuarters.value = ["不限"];
      }
    }
    searchEvent(false);
  }
}


const provinceMoreEvent = () => {
  bindData.provinceMax = bindData.provinceMax < bindData.provinceTotalCount + 1 ? (bindData.provinceMax + searchItemSize.value) : bindData.provinceMax
  if (bindData.provinceMax > bindData.provinceTotalCount + 1) {
    bindData.provinceMax = bindData.provinceTotalCount + 1;
  }
}

const brandMoreEvent = () => {
  bindData.brandMax = bindData.brandMax < bindData.brandTotalCount + 1 ? (bindData.brandMax + searchItemSize.value) : bindData.brandMax
  if (bindData.brandMax > bindData.brandTotalCount + 1) {
    bindData.brandMax = bindData.brandTotalCount + 1;
  }
}

const joinCategoryMoreEvent = () => {
  bindData.joinCategoryMax = bindData.joinCategoryMax < bindData.joinCategoryTotalCount + 1 ? (bindData.joinCategoryMax + searchItemSize.value) : bindData.joinCategoryMax
  if (bindData.joinCategoryMax > bindData.joinCategoryTotalCount + 1) {
    bindData.joinCategoryMax = bindData.joinCategoryTotalCount + 1;
  }
}

const sortSearchEvent = () => {
  if (pushTimeUpSort.value) {
    pushTimeUpSort.value = false;
    bindData.pageParams.orderingRule = "ASC"
  } else {
    bindData.pageParams.orderingRule = "DESC"
    pushTimeUpSort.value = true;
  }
  reloadSearchEvent();
}


const handleToDetail = (item: any) => {
  router.push('/frontDesk/fdInvestList/fdInvestDetail/' + item.id)
}

const handleShow = () => {
  isShow.value = true;
};

const handleHide = () => {
  isShow.value = false;
};

const value = ref("");
const houseAveragePriceCodes = [
  {
    value: "",
    label: "请选择房屋均价",
  },
  {
    value: 1,
    label: "<1万",
  },
  {
    value: 2,
    label: "1~2万",
  },
  {
    value: 3,
    label: "2~3万",
  },
  {
    value: 4,
    label: "3~5万",
  },
  {
    value: 5,
    label: "5~10万",
  },
  {
    value: 6,
    label: ">10万",
  },
];

//1：<200户 2：200-500户 3：501-1000户 4.1001-2000户 5.>2000户
const roomNumberCodes = [
  {
    value: "",
    label: "请选择交房户数",
  },
  {
    value: '1-200',
    label: "<200户",
  },
  {
    value: "200-500",
    label: "200-500户",
  },
  {
    value: "501-1000",
    label: "501-1000户",
  },
  {
    value: "1001-2000",
    label: "1001-2000户",
  },
  {
    value: "2000-100000",
    label: ">2000户",
  },
];

const paymentModels = [
  {
    value: "",
    label: "请选择收费模式",
  },
  {
    value: 1,
    label: "一次性进场费",
  },
  {
    value: 2,
    label: "进场费+销售提成",
  },
  {
    value: 3,
    label: "销售提成",
  },
  {
    value: 4,
    label: "包盘（一次性进场费）",
  },
  {
    value: 5,
    label: "包盘（进场费+销售提成）",
  },
  {
    value: 6,
    label: "面议",
  },
];

const paymentWays = [
  {
    value: "",
    label: "请选择收款方式",
  },
  {
    value: 1,
    label: "公司代收货款",
  },
  {
    value: 2,
    label: "公司不代收货款",
  },
  {
    value: 3,
    label: "其他",
  },
];

const joinQuantitys = [
  {
    value: "",
    label: "请选择计划招商数量",
  },
  {
    value: "1",
    label: "1家",
  },
  {
    value: "2",
    label: "2家",
  },
  {
    value: "3,5",
    label: "3~5家",
  },
  {
    value: "6,10",
    label: "6~10家",
  },
  {
    value: "10,10000",
    label: "10家以上",
  },
];

decorateTypeEvent();
joinCategoryEvent();
houseNatureEvent();
activityEvent(false);
provinceEvent();
activityBrandEvent();
quarterEvent();
timeTypeEvent();

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_sort_down = _resolveComponent("sort-down")!
  const _component_sort_up = _resolveComponent("sort-up")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(bindData).tags.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).tags, (tag) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  onClose: ($event: any) => (removeSearchTagEvent(tag.type)),
                  key: tag.name,
                  class: "mx-1",
                  closable: "",
                  type: tag.type,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClose", "type"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_collapse, {
          class: "fd-invest-list-search-hd",
          modelValue: activeNames.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((activeNames).value = $event)),
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              title: "筛选条件",
              name: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_form, { "label-width": "100px" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "项目省份：" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: selectProvinces.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectProvinces).value = $event)),
                            onChange: reloadSearchEvent,
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox_button, { label: "不限" }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).provinces.slice(0, _unref(bindData).provinceMax), (item) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                  key: item.province,
                                  label: item.province
                                }, null, 8, ["label"]))
                              }), 128)),
                              (_unref(bindData).provinceTotalCount > searchItemSize.value && _unref(bindData).provinceMax < _unref(bindData).provinceTotalCount)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    class: "bbs-search-more",
                                    type: "text",
                                    size: "large",
                                    onClick: provinceMoreEvent
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_7,
                                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ArrowDownBold)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "招商品类：" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: selectJoinCategorys.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectJoinCategorys).value = $event)),
                            onChange: reloadSearchEvent,
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox_button, { label: "不限" }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).joinCategorys.slice(0, _unref(bindData).joinCategoryMax), (item) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                  key: item.id,
                                  label: item.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128)),
                              (_unref(bindData).joinCategoryTotalCount > searchItemSize.value && _unref(bindData).joinCategoryMax < _unref(bindData).joinCategoryTotalCount)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    class: "bbs-search-more",
                                    type: "text",
                                    size: "large",
                                    onClick: joinCategoryMoreEvent
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8,
                                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ArrowDownBold)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "地产品牌：" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: selectBrandNames.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectBrandNames).value = $event)),
                            onChange: reloadSearchEvent,
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox_button, { label: "不限" }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).brandNames.slice(0, _unref(bindData).brandMax), (item) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                  key: item.name,
                                  label: item.name
                                }, null, 8, ["label"]))
                              }), 128)),
                              (_unref(bindData).brandTotalCount > searchItemSize.value && _unref(bindData).brandMax < _unref(bindData).brandTotalCount)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    class: "bbs-search-more",
                                    type: "text",
                                    size: "large",
                                    onClick: brandMoreEvent
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9,
                                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ArrowDownBold)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "交房日期：" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: selectQuarters.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectQuarters).value = $event)),
                            size: "large",
                            onChange: reloadSearchEvent
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox_button, { label: "不限" }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).quarters, (item) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                  key: item,
                                  label: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item) + "季度 ", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "上线时间：" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: selectTimeType.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectTimeType).value = $event)),
                            size: "large",
                            onChange: reloadSearchEvent
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).timeSearchTypes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                                  key: item.key,
                                  label: item.key
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.value), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_container, { class: "fd-invest-list-box-xz" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).pageParams.filtrate.houseAveragePriceCode,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).pageParams.filtrate.houseAveragePriceCode) = $event)),
                        onChange: reloadSearchEvent,
                        class: "m-2",
                        placeholder: "选择房屋均价"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(houseAveragePriceCodes, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).pageParams.filtrate.roomNumberCode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).pageParams.filtrate.roomNumberCode) = $event)),
                        class: "m-2",
                        onChange: reloadSearchEvent,
                        placeholder: "选择交房户数"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(roomNumberCodes, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).pageParams.filtrate.houseNatureId,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).pageParams.filtrate.houseNatureId) = $event)),
                        class: "m-2",
                        onChange: reloadSearchEvent,
                        placeholder: "选择房屋性质"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "请选择房屋性质",
                            value: ""
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).houseNatures, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).pageParams.filtrate.decorateTypeId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).pageParams.filtrate.decorateTypeId) = $event)),
                        class: "m-2",
                        onChange: reloadSearchEvent,
                        placeholder: "选择装修类型"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "请选择装修类型",
                            value: ""
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).decorateTypes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).pageParams.filtrate.paymentModel,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).pageParams.filtrate.paymentModel) = $event)),
                        class: "m-2",
                        onChange: reloadSearchEvent,
                        placeholder: "选择收费模式"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentModels, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).pageParams.filtrate.paymentWay,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).pageParams.filtrate.paymentWay) = $event)),
                        class: "m-2",
                        onChange: reloadSearchEvent,
                        placeholder: "选择收款方式"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentWays, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(bindData).pageParams.filtrate.joinQuantitys,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bindData).pageParams.filtrate.joinQuantitys) = $event)),
                        class: "m-2",
                        onChange: reloadSearchEvent,
                        placeholder: "选择计划招商数量"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(joinQuantitys, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_container, { class: "fd-invest-list-box-bt" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: sortSearchEvent
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          (!pushTimeUpSort.value)
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_sort_down)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (pushTimeUpSort.value)
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_sort_up)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_checkbox, {
                        modelValue: isApply.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isApply).value = $event)),
                        onChange: reloadSearchEvent
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_container, { class: "fd-invest-box-line" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).pageResult.result, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "fd-invest-box-item",
                key: item.id,
                onClick: () => handleToDetail(item)
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_image, {
                    class: "",
                    src: item.thumbnailUrl
                  }, null, 8, ["src"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["fd-invest-box-item-img-status", _unref(bindData).calssType[item.status]])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(bindData).type[item.status]), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_container, { class: "fd-invest-box-item-info-tp" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(item.name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    gutter: 20,
                    class: "fd-index-box-item-info-ct list-row"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 14,
                        class: "col-left"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.deliveryDateString) + "收楼 | " + _toDisplayString(item.decorateTypeName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        span: 10,
                        class: "col-right",
                        style: {"color":"red"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.phaseName), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    gutter: 20,
                    class: "fd-index-box-item-info-bt list-row"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 14,
                        class: "col-left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_el_image, {
                              class: "bbs-list-item-logo-icon",
                              mode: "widthfix",
                              src: item.companyLogo,
                              style: {"width":"35px","height":"35px","margin-right":"3px"}
                            }, null, 8, ["src"]),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(item.companyName), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      (item.roomNumber > 0)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 10,
                            class: "col-right",
                            style: {"color":"red"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.roomNumber) + "户 ", 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 8, _hoisted_13))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_22, [
          (
            _unref(bindData).pageResult.result.length < _unref(bindData).pageResult.totalCount
          )
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "load-more-button",
                type: "text",
                size: "large",
                onClick: loadPageDataEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 加载更多..." + _toDisplayString(remainCount.value), 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowDownBold)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})